import { render, staticRenderFns } from "./LocationCollectionFiltersNewV2.vue?vue&type=template&id=63a3f7fc"
import script from "./LocationCollectionFiltersNewV2.vue?vue&type=script&lang=ts"
export * from "./LocationCollectionFiltersNewV2.vue?vue&type=script&lang=ts"
import style0 from "./LocationCollectionFiltersNewV2.vue?vue&type=style&index=0&id=63a3f7fc&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('63a3f7fc')) {
      api.createRecord('63a3f7fc', component.options)
    } else {
      api.reload('63a3f7fc', component.options)
    }
    module.hot.accept("./LocationCollectionFiltersNewV2.vue?vue&type=template&id=63a3f7fc", function () {
      api.rerender('63a3f7fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/companyContractors/LocationCollectionFiltersNewV2.vue"
export default component.exports